// import { addClass, removeClass } from '../utils/CssUtils';
import { addEventListener } from '../utils/EventUtils';
import { catchPromiseException } from '../utils/JsUtils';
import AbstractPageController from './AbstractPageController';
import Logger from '../utils/Logger';

export default class FilmsCategoryController extends AbstractPageController {
    constructor(...args) {
        super(...args);
        Logger.log('FilmsCategoryController->constructor()');

        this.classname = 't-films-category';
        this.mediaFullscreenClassname = this.getClassname('__media-fullscreen');
        this.mediaFullscreenDimmedClassname = this.mediaFullscreenClassname + '--dimmed';
        this.filmsGridClassname = 'c-films-grid';
        this.contentClassname = 'c-content-card';
        this.contentCardDimmedClassname = this.contentClassname + '--dimmed';
        this.isMediaFullscreenVideoMuted = true;
        this.initDomElements();
        this.addEventListeners();
        this.ready();
    }

    initDomElements() {
        this.$mediaFullscreen = this.app.$body.querySelector(this.getSelector('__media-fullscreen'));
        this.$mediaFullscreenVideo = this.app.$body.querySelector(this.getSelector('__media-fullscreen .c-media-cover__media'));
        this.$filmsGrid = this.app.$body.querySelector('.' + this.filmsGridClassname);
        this.$contentCards = this.app.$body.querySelectorAll('.' + this.contentClassname);
    }

    addEventListeners() {
        if (this.$mediaFullscreen) {
            this.boundMediaFullscreenMouseEnterEventListener = this.mediaFullscreenMouseEnterEventListener.bind(this);
            addEventListener(this.$mediaFullscreen, 'mouseenter', this.boundMediaFullscreenMouseEnterEventListener);
            addEventListener(this.$mediaFullscreen, 'touchstart', this.boundMediaFullscreenMouseEnterEventListener);

            this.boundMediaFullscreenMouseLeaveEventListener = this.mediaFullscreenMouseLeaveEventListener.bind(this);
            addEventListener(this.$mediaFullscreen, 'mouseleave', this.boundMediaFullscreenMouseLeaveEventListener);
            addEventListener(this.$mediaFullscreen, 'touchend', this.boundMediaFullscreenMouseLeaveEventListener);
        }

        if (this.$contentCards) {
            this.boundContentCardsMouseEnterEventListener = this.contentCardsMouseEnterEventListener.bind(this);
            addEventListener(this.$contentCards, 'mouseenter', this.boundContentCardsMouseEnterEventListener);
            addEventListener(this.$contentCards, 'touchstart', this.boundContentCardsMouseEnterEventListener);

            this.boundContentCardsMouseLeaveEventListener = this.contentCardsMouseLeaveEventListener.bind(this);
            addEventListener(this.$contentCards, 'mouseleave', this.boundContentCardsMouseLeaveEventListener);
            addEventListener(this.$contentCards, 'touchend', this.boundContentCardsMouseLeaveEventListener);

            this.app.on('media-gallery.open', this.mediaGalleryOpenListener.bind(this));
            this.app.on('media-gallery.close', this.mediaGalleryCloseListener.bind(this));
            console.log('hello');
        }

    }

    mediaFullscreenMouseEnterEventListener() {
        this.mouseEnterEventListener(this.$mediaFullscreen, null);
    }

    contentCardsMouseEnterEventListener(e) {
        this.mouseEnterEventListener(null, e.target);
    }

    mouseEnterEventListener(mediaFullscreen, contentCard) {
        if (mediaFullscreen) {
            // removeClass(this.$mediaFullscreen, this.mediaFullscreenDimmedClassname);
            // removeClass(this.$contentCards, this.contentCardDimmedClassname);
            this.mediaFullscreenVideoPlay();
            return;
        }

        // addClass(this.$mediaFullscreen, this.mediaFullscreenDimmedClassname);
        // addClass(this.$contentCards, this.contentCardDimmedClassname);
        if (contentCard) {
            this.mediaFullscreenVideoPause();
            // removeClass(contentCard, this.contentCardDimmedClassname);
        }
    }

    mediaFullscreenMouseLeaveEventListener() {
        this.mouseLeaveEventListener();
    }

    contentCardsMouseLeaveEventListener() {
        this.mouseLeaveEventListener();
    }

    mouseLeaveEventListener() {
        // removeClass(this.$mediaFullscreen, this.mediaFullscreenDimmedClassname);
        // removeClass(this.$contentCards, this.contentCardDimmedClassname);
        this.mediaFullscreenVideoPlay();
    }

    mediaFullscreenVideoPause() {
        if (this.$mediaFullscreenVideo) {
            clearTimeout(this.mediaFullscreenVideoPlayTimeout);
            catchPromiseException(this.$mediaFullscreenVideo.pause());
        }
    }

    mediaFullscreenVideoPlay() {
        if (this.$mediaFullscreenVideo) {
            this.mediaFullscreenVideoPlayTimeout = setTimeout(() => {
                catchPromiseException(this.$mediaFullscreenVideo.play());
            }, 1000 / 60);
        }
    }

    mediaGalleryOpenListener() {
        if (this.$mediaFullscreenVideo) {
            this.isMediaFullscreenVideoMuted = this.$mediaFullscreenVideo.muted;
            if (!this.isMediaFullscreenVideoMuted) {
                this.$mediaFullscreenVideo.muted = true;
            }
        }
    }

    mediaGalleryCloseListener() {
        if (this.$mediaFullscreenVideo) {
            this.$mediaFullscreenVideo.muted = this.isMediaFullscreenVideoMuted;
        }
    }

    update() { }

    destroy() { }
}
